import { matchPath } from 'react-router-dom';

const agendaPagePath = '/agenda';
const communityPagePath = '/community';

export const getSizeByPage = (pathname: string, baseRoute: string) => {
    const isAgendaPage = matchPath(baseRoute + agendaPagePath, pathname);
    const isCommunityPage = matchPath(baseRoute + communityPagePath, pathname);

    if (isAgendaPage || isCommunityPage) {
        return 'large';
    }
    return 'small';
};
